import announceRoutes from './routes'

/* @ngInject */
const announceRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(announceRoutes.index.path, {
      url: announceRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'announceCtrl',
    })
    .state(announceRoutes.selectWagons.path, {
      url: announceRoutes.selectWagons.url,
      template: require('./templates/selectWagons.html'),
    })
    .state(announceRoutes.report.path, {
      url: announceRoutes.report.url,
      template: require('./templates/report.html'),
    })
}

export default announceRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/announce/announce.routes.js